import { type FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { ModalContext } from '@/components/Modals/Modal/config';
import { H3 } from '@/components/Typography/Typography';
import {
  type MainButtonProps,
  PurpleButton,
} from '@/components/ui/Button/Button';
import { Picture } from '@/components/ui/Picture/Picture';

import { DiceGameModalsContext } from '../DiceGameModals/context';

import dicePng from '/img/dice-game/dice.png';
import diceWebp from '/img/dice-game/dice.webp';
import flashPng from '/img/icons/flash.png';
import flashWebp from '/img/icons/flash.webp';

interface BuyRollEnergyButtonProps extends Omit<MainButtonProps, 'text'> {
  kind: 'dice' | 'energy';
}

const BuyRollEnergyButton: FC<BuyRollEnergyButtonProps> = ({
  kind,
  ...props
}) => {
  const { t } = useTranslation();
  const { openRechargeEnergy } = useContext(DiceGameModalsContext);
  const { openModal } = useContext(ModalContext);

  const images = {
    dice: {
      png: dicePng,
      webp: diceWebp,
    },
    energy: {
      png: flashPng,
      webp: flashWebp,
    },
  };

  const image = images[kind];

  return (
    <PurpleButton
      {...props}
      onClick={
        kind === 'dice'
          ? (): void =>
              openModal({ renderKind: 'buyDiceModal', props: undefined })
          : openRechargeEnergy
      }
      className={cn('flex items-center gap-2', props.className)}
    >
      <Picture
        className="w-6 h-6 shrink-0"
        img={image.png}
        webp={image.webp}
        alt="dice"
      />
      <H3 weight="extrabold" className={'huge-text'}>
        {t('Buy')}
      </H3>
    </PurpleButton>
  );
};

export { BuyRollEnergyButton };
